import React from "react";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/Footer/Footer";
import { MFAModal } from "../../components/Modals/MFAModal/mfa-setup-modal";

export default function RegistrationMFASetupPage() {
 

  return (
    <>
      <Navbar />
      <section className="register-mfa-setup-bg">
        <MFAModal id="register-mfa-setup-modal" isActive={true} header={"Chose Your MFA Preference"} showDivider={true} animate={false} />
      </section>
      <Footer />
    </>
  );
}
